import type { Category } from "./types";

// The launch set is Onboarding + Tooling. The other categories are wired up so
// dropping a markdown file with `category: ads-ops` (etc.) light the nav up
// automatically without code changes.
export const CATEGORIES: Category[] = [
  {
    id: "onboarding",
    label: "Onboarding",
    description: "Your first week at Legacy Growth Partners",
    order: 1,
  },
  {
    id: "tooling",
    label: "Tooling & Access",
    description: "Every tool we use, and how to get into it",
    order: 2,
  },
  {
    id: "client-delivery",
    label: "Client Delivery",
    description: "Onboarding, reporting, reviews, offboarding",
    order: 3,
  },
  {
    id: "ads-ops",
    label: "Ads Ops",
    description: "Daily checks, optimisation, scaling decisions",
    order: 4,
  },
  {
    id: "sales",
    label: "Sales",
    description: "Discovery, follow-up, proposals, objections",
    order: 5,
  },
  {
    id: "internal",
    label: "Internal Ops",
    description: "Time-off, expenses, comms, culture",
    order: 6,
  },
];

export function categoryById(id: string): Category | undefined {
  return CATEGORIES.find((c) => c.id === id);
}
